// to easily copy and paste components
import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../../common/parent';
import DownArrow from "../../images/arrow-down.png";
import FreezeButton from "../../images/freeze-button.png";
import LeftArrow from "../../images/left-arrow.png";
import UpArrow from "../../images/up-arrow.png";
import $ from 'jquery';
import {DropDown} from "../../common/simple/dropDown";
import {BllinkLogger} from "../../common/utils/bllink_loggers";
import './uploadPaymentSettings.css';
import XLSX from 'xlsx';

//this files mapping only because we can't download from lambda and
// we can't set the file name when downloading from s3
// todo solve this
let filesMapping = {
    'he': {
        // can we use default always?
        'monthly': {
            'default': 'https://s3.amazonaws.com/PtoPTempHosts/%D7%AA%D7%A9%D7%9C%D7%95%D7%9E%D7%99%D7%9D+%D7%97%D7%95%D7%93%D7%A9%D7%99%D7%99%D7%9D.xlsx'
        },
        'oneTime': 'https://s3.amazonaws.com/PtoPHostsAvatars/+%D7%98%D7%95%D7%A4%D7%A1+%D7%AA%D7%A9%D7%9C%D7%95%D7%9D+%D7%97%D7%93+%D7%A4%D7%A2%D7%9E%D7%99+%D7%91%D7%9C%D7%99%D7%A0%D7%A7.xlsx',
        'tenantList': 'https://s3.amazonaws.com/PtoPTempHosts/newTenantTemplate.xlsx',
        // 'tenantListMultipleContacts': 'https://s3.amazonaws.com/PtoPTempHosts/newTenantTemplateMultipleContacts.xlsx',
        'collectionStatus': 'https://s3.amazonaws.com/PtoPTempHosts/collectionStatus.xlsx',
    },
    'en': {
        'monthly': {
            'default': 'https://s3.amazonaws.com/PtoPTempHosts/Monthly_Payments.xlsx'
        },
        'oneTime': 'https://s3.amazonaws.com/PtoPTempHosts/Bllink_One_Time_Payment_Form.xlsx',
        'tenantList': 'https://s3.amazonaws.com/PtoPTempHosts/New_Tenant_Template_EN.xlsx',
        'collectionStatus': 'https://s3.amazonaws.com/PtoPTempHosts/collectionStatus.xlsx',
    }
}

export class UploadDownloadToolBar extends Parent {

    constructor(props) {
        super(props);

        BllinkLogger.info(`props.parentState`, props.parentState);
        this.state = props.parentState;
        this.bindFreezeUnFreezeButton.bind(this);
        this.renderOneTimeControl.bind(this);
        this.renderYearDropdown.bind(this);
        this.bindDownloadLink.bind(this);
        this.readURL.bind(this);
    }

    async componentDidMount() {
        await this.verifyLoggedIn();
        this.bindDownloadLink();
        this.bindExcelUpload();
        this.bindFreezeUnFreezeButton();
    }

    bindExcelUpload(){
        const thisObj = this;
        $(".js-upload-excel-monthly").unbind('change').bind('change', function(e){
            e.preventDefault();
            thisObj.readURL(this);
        });

        $(".js-upload-link").unbind('click').bind('click', function(e){
            e.preventDefault();
            thisObj.readURL(this);
        });
    }

    readURL(input) {
        const buildingID = this.props.buildingID;

        try {
            if (input.files && input.files[0]) {
                let reader = new FileReader();
                reader.fileName = input.files[0].name;
                reader.onload = async (e) => {
                    let cfb = XLSX.read(e.target.result, {type: 'binary'});
                    let sheetData = cfb.Sheets[cfb.SheetNames[0]];
                    let jsonData = XLSX.utils.sheet_to_json(sheetData);
                    if (this.state.tenantList) await this.props.onUploadTenantListFile(jsonData);
                    else if (this.state.collectionStatus) await this.props.onUploadCollectionStatusFile(jsonData);
                    else await this.uploadPaymentSettingsFile(this.props.year, buildingID, jsonData);
                }

                reader.readAsBinaryString(input.files[0]);
            }
        } catch (e) {
            BllinkLogger.error('error in processing file to excel', e);
        }

    }

    bindDownloadLink(){
        let thisObj = this;

        $('#download-monthly-excel').unbind('click').bind('click', async function(e){
            e.preventDefault();
            thisObj.downloadExcel(thisObj);
        })

    }

    downloadExcel(thisObj){
        let paymentType;
        const { tenantList, collectionStatus, isMonthly } = thisObj.state;
        if (tenantList) paymentType = 'tenantList'
        else if (collectionStatus) paymentType = 'collectionStatus'
        else if (isMonthly) paymentType = 'monthly'
        else paymentType = 'oneTime'

        const language = thisObj.props.i18n?.language;
        const files = filesMapping[language] ?? filesMapping.he;
        let url = files[paymentType];
        BllinkLogger.info(`paymentType ${paymentType} url ${url}`)
        if (typeof url !== 'string' && !(url instanceof String)){
            url = url.default
        }
        let win = window.open(url, '_blank');
        win.focus();
    }

    renderYearDropdown() {
        if (!this.props.onYearChanged) {
            return <div/>
        }
        const year = parseInt(this.timeUtils.getCurrentYear());
        const yearsOptions = [year - 1, year, year + 1];

        return (
            <DropDown
                className={'select-small'}
                onSelectChange={this.props.onYearChanged}
                value={this.props.year}
                options={yearsOptions}
            />
        )
    }

    bindFreezeUnFreezeButton(){
        const thisObj = this;
        $('#freeze-unfreeze-one-time').unbind('click').bind('click', async function(e) {
            e.preventDefault();
            const action = $(e.target).attr('action');
            thisObj.startLoader();
            BllinkLogger.info(`freeze-unfreeze-one-time clicked ${action}`);
            const result = await thisObj.client.post(`/managers/one-time-payment-settings/${thisObj.props.buildingID}/${thisObj.props.oneTimeSettingsID}?action=${action}`);
            BllinkLogger.info(`result freeze is `, result);
            window.location.reload();

        });
    }

    renderOneTimeControl() {
        const {t} = this.props;
        BllinkLogger.info(`this.props.parentState`, this.props.parentState)
        const showTheControls = (this.props.parentState.isOneTime && this.props.parentState.isOneTime !== 'add')
        if (!showTheControls) {
            return <div/>
        }

        const isFrozen = (this.props.parentState.isFrozen);
        const text = isFrozen ? t('payment_settings.unfreezeOneTime'): t('payment_settings.freezeOneTime');
        const action = isFrozen ? 'unfreeze': 'freeze';
        const textClass = isFrozen ? 'freeze-text-full' : 'freeze-text-half' ;
        const linkClass = isFrozen ? 'freeze-unfreeze-one-time' : '' ;
        const image = isFrozen ? '': <img action={action} alt="freeze button" className={"freeze-image"} src={FreezeButton}/>;

        return (
            <div className="btn-with-icon" id="down-2">
                <a id="freeze-unfreeze-one-time"
                   className={linkClass}
                   action={action}
                   href="/">
                    <span action={action} className={textClass}> {text} </span>
                    {image}
                </a>
            </div>
        )
    }


    render() {
        const {t} = this.props;
        const year = this.props.year ? parseInt(this.props.year): null;

        return (
            <div id="add-pay">
                <div id="down" className='label'>
                    <a href="/">{t('payment_settings.uploadExplain')}
                        <img alt="point to file" src={LeftArrow}/></a>
                </div>
                <div className="btn-with-icon" id="down-2">
                    <a id="download-monthly-excel"
                       year={year}
                       href="/">{t('payment_settings.downloadFile')}
                        <img alt="download file" src={DownArrow}/>
                    </a>
                </div>
                <div className="btn-with-icon" id="down-3">
                    <a id='js-upload-link' href="#">{t('payment_settings.uploadFile')}
                        <img alt="upload file" src={UpArrow}/>
                        <input type="file" id="excel-monthly-upload"
                               accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                               className={`file_upload-input js-upload-excel-monthly clickable`} />
                    </a>
                </div>
                {this.renderYearDropdown()}
                {this.renderOneTimeControl()}
            </div>
        )
    }
}

export default withTranslation()(UploadDownloadToolBar);

